import React, { memo } from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

const Checkbox = memo(
    ({
        checked,
        id = '',
        name = '',
        onChange = () => null,
        onClick = () => null,
        disabled = false,
    }) => {
        const changeHandler = (event) => {
            onChange(event.target.checked);
        };
        const classNames = ['custom-checkbox'];
        if (disabled) classNames.push('custom-checkbox__disabled');

        return (
            <div className={classNames.join(' ')}>
                <input
                    className={disabled ? 'custom-checkbox__disabled' : null}
                    type="checkbox"
                    checked={!disabled ? checked : false}
                    id={id}
                    name={name}
                    onChange={changeHandler}
                    onClick={onClick}
                    disabled={disabled}
                />
            </div>
        );
    },
);

Checkbox.propTypes = {
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    onClick: PropTypes.func,
    id: PropTypes.string,
    name: PropTypes.string,
};

export default Checkbox;
